module.exports = __webpack_public_path__ + "img/Group_44667.88de4e19.png";